import { render, staticRenderFns } from "./DirectCaso.vue?vue&type=template&id=53368932&"
import script from "./DirectCaso.vue?vue&type=script&lang=js&"
export * from "./DirectCaso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports